export default "__VITE_ASSET__C56Y$Tn$__"